<template>
  <div class="row mx-3 py-2 p-0 justify-content-start">
    <span class="form-label align-self-start size-12 p-0">勤務地</span>
    <div class="w-100 p-0 d-flex gap-0 flex-wrap">
      <div
        v-for="(prefecture, idx) in props.prefectures"
        :key="prefecture.key"
        class="mb-2 me-2 d-flex align-items-center p-0 mw-100"
      >
        <Field
          :id="`candidate_resume_prefectures_${idx}`"
          :name="`candidate_resume_prefectures[${idx}]`"
        >
          <div class="align-items-center col-auto d-flex flex-nowrap w-100">
            <p
              class="bg-silver-primary px-3 py-1 mb-0 border border-fourth rounded-2 me-1 flex-shrink-1"
            >
              {{ prefecture.name }}
              <template v-if="prefecture.cities.length > 0">
                /
                <template v-for="(city, index) in prefecture.cities">
                  <template v-if="index > 0">,</template>
                  {{ city.name }}
                </template>
              </template>
            </p>
            <img
              src="@/assets/image/icon-close-delete.svg"
              role="button"
              class="border rounded-circle border-third p-0d25"
              @click="onRemovePrefecture(prefecture.id)"
            />
          </div>
        </Field>
      </div>
    </div>
    <div class="col-md-12 d-flex justify-content-center mt-2">
      <AddButton class="mw-184x" title="勤務地を追加する" @click="addPefecture" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { Field } from 'vee-validate';
import AddButton from '@/components/common/Button/AddButton/index.vue';

const addPefecture = (): void => {
  emit('open');
};

const onRemovePrefecture = (prefectureId: number): void => {
  emit('remove', prefectureId);
};

const props = defineProps({
  prefectures: {
    type: Array as unknown as () => any,
    required: false,
  },
});

const emit = defineEmits(['open', 'remove']);
</script>
